import React from 'react'
import { Image, Platform } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import {
  B4,
  Icon,
  SH1,
  SH3,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { useExperiments } from '@zet/experiments'

import { useMyTeamsBrandPayout } from '../../api/brands/hooks'
import { IBrandComsData } from '../../api/brands/types'
import { getTagType } from '../../utils'
import AnimatedChip from './animatedChip'

interface IGradientView {
  isRenderTag?: boolean
  onHold?: boolean
  isHighApproval?: boolean
  content?: IBrandComsData
  tier?: any
  partnerId?: string | number
  tierData?: any
  isRecommendationFlow?: boolean
  loyaltyPayout: any
}

const GradientView = ({
  onHold,
  isRenderTag,
  tierData,
  tier,
  content,
  partnerId,
  isHighApproval,
  isRecommendationFlow,
  loyaltyPayout,
}: IGradientView) => {
  const isWeb = Platform.OS === 'web'
  const itemType = getTagType(content, onHold, isHighApproval, partnerId)
  const { data: experiment } = useExperiments()
  const { data: teamsBrandPayout } = useMyTeamsBrandPayout(partnerId)

  return (
    <Stack
      className="h-[62] rounded-t-lg"
      style={{
        backgroundColor: content?.colorGradient?.[0] || zetColors.primary[20],
      }}
    >
      <XStack className="justify-between rounded-tl-lg rounded-tr-lg">
        <Stack className={`ml-4/2 mt-3 ${isRenderTag ? 'mb-3' : 'mt-3'}`}>
          {Boolean(content?.logo) && (
            <Image
              source={{ uri: content?.logo }}
              style={{
                width: 100,
                height: 35,
                resizeMode: 'contain',
              }}
            />
          )}
        </Stack>
        {isRenderTag && !itemType?.hideTag && (
          <Stack>
            <XStack
              className="items-center space-x-1 rounded-bl-md rounded-tr-lg px-2"
              style={{
                backgroundColor: itemType.bgColor,
                paddingVertical: 3,
              }}
            >
              {itemType.icon ? (
                itemType.icon
              ) : (
                <Icon
                  type={itemType.iconName}
                  color={zetColors.neutral.white100}
                  size={20}
                />
              )}
              <B4 className="text-white">{itemType.title}</B4>
            </XStack>
            {!isWeb && (
              <Stack
                className={`items-end justify-end ${
                  isWeb && !itemType.iconName ? 'mt-3' : ''
                }`}
              >
                {content?.commission ? (
                  experiment?.UI_HighestPayoutFlow && !isRecommendationFlow ? (
                    <AnimatedChip
                      tier={tier}
                      categoryId={content?.categoryId}
                      content={content}
                      tierData={tierData}
                      isRecommendationFlow={isRecommendationFlow}
                      onHold={onHold}
                      partnerId={partnerId}
                      loyaltyPayout={loyaltyPayout}
                    />
                  ) : (
                    <AnimatedChip
                      tier={tier}
                      categoryId={content?.categoryId}
                      isRecommendationFlow={isRecommendationFlow}
                      partnerId={partnerId}
                      content={content}
                      loyaltyPayout={loyaltyPayout}
                    />
                  )
                ) : (
                  <Stack className="mt-5" />
                )}
                {teamsBrandPayout?.payout && APP_NAME === MY_TEAMS_ADVISOR && (
                  <Stack
                    className="bg-primary-150 -mt-2 mr-3 items-center rounded"
                    style={{ zIndex: 100 }}
                  >
                    <SH3
                      className="z-10 py-1 pl-2 pr-1 text-center text-white"
                      numberOfLines={1}
                    >
                      {teamsBrandPayout?.payout}
                    </SH3>
                  </Stack>
                )}
              </Stack>
            )}
          </Stack>
        )}
      </XStack>
    </Stack>
  )
}

const BrandTitle = ({ name }: { name: string }) => {
  return (
    <SH1 className="text-grays-100 mt-4/2" numberOfLines={1}>
      {name}
    </SH1>
  )
}

export { BrandTitle, GradientView }
